export const breakpoints = {
  sm: 600,
  md: 768,
  lg: 900,
  xl: 1400,
} as const;

export const media = {
  sm: `@media (max-width: ${breakpoints.sm}px)`,
  md: `@media (max-width: ${breakpoints.md}px)`,
  lg: `@media (max-width: ${breakpoints.lg}px)`,
  xl: `@media (max-width: ${breakpoints.xl}px)`,
} as const;
